"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cartesianTransform = void 0;
const cartesianTransform = function (image, pixelX, pixelY, options = {}) {
    const { translation, depthOverride } = options;
    let { x, y, z } = image.toCameraCoordinates(pixelX, pixelY, depthOverride);
    if (translation) {
        x += options.translation.dX;
        y += options.translation.dY;
        z += options.translation.dZ;
    }
    return { x, y, z };
};
exports.cartesianTransform = cartesianTransform;
